import React from 'react'
import {
  broadcast,
  listen,
  stop_listen,
  post_gql,
  INIT_VIDEO_SETTINGS,
  video_layer,
  video_layer_edges
} from '../../utils'
import * as turf from '@turf/turf'

class VideoTool extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'cursor',
      mouse_down_coords: false,
      container_mouse_coords: false,
      edit_layer_id: false,
      top: 10,
      left: 30,
      video_settings: INIT_VIDEO_SETTINGS,
      user_id: false,
      hidden: false,
      common_hidden: false,
      layout_hidden: true,
      background_hidden: true,
      border_hidden: true,
      outline_hidden: true,
      listners: []
    }
  }

  componentDidMount(){
    const listners = [
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_mode_change", fnc: ({detail}) => {
        broadcast("remove_layer", `${this.state.edit_layer_id}_1_video_edge`)
        broadcast("remove_layer", `${this.state.edit_layer_id}_2_video_edge`)
        broadcast("remove_layer", `${this.state.edit_layer_id}_3_video_edge`)
        broadcast("remove_layer", `${this.state.edit_layer_id}_4_video_edge`)
        this.setState({mode: detail.mode, edit_layer_id: false})
      }},
      {type: "toolbar_delete", fnc: ({detail}) => {
        if (this.state.edit_layer_id) {
          post_gql(
            `mutation {geomapLayerDelete(layer_id: ${this.state.edit_layer_id})}`,
            resp => {
              broadcast("remove_layer", this.state.edit_layer_id)
              broadcast("remove_layer", `${this.state.edit_layer_id}_1_video_edge`)
              broadcast("remove_layer", `${this.state.edit_layer_id}_2_video_edge`)
              broadcast("remove_layer", `${this.state.edit_layer_id}_3_video_edge`)
              broadcast("remove_layer", `${this.state.edit_layer_id}_4_video_edge`)

              broadcast("toolbar_mode_change", {mode: 'cursor'})
              broadcast("layer_edit", {id: false, type: "video"})
            }
          )
        }
      }},
      {type: "user_map_hover", fnc: ({detail}) => {
        if (detail.id !== this.props.user_id || detail.mode === "video"){
          var coord1 = detail.coordinate
          var line = turf.lineString([coord1, [coord1[0] + 1, coord1[1]]]);
          var along = turf.along(line, 40, {units: 'meters'});
          var coord2 = along.geometry.coordinates

          line = turf.lineString([coord2, [coord2[0], coord2[1] - 1]]);
          along = turf.along(line, 20, {units: 'meters'});
          var coord3 = along.geometry.coordinates

          line = turf.lineString([coord3, [coord3[0] - 1, coord2[1]]]);
          along = turf.along(line, 40, {units: 'meters'});
          var coord4 = along.geometry.coordinates

          var settings = {
            ...this.state.video_settings,
            coord1: coord1,
            coord2: coord2,
            coord3: coord3,
            coord4: coord4
          }

          if (detail.id === this.props.user_id)
            this.setState({video_settings: settings})


          broadcast(
            "add_or_replace_layer",
            video_layer({id: `${detail.id}_position`, video_settings: settings})
          )
        }
      }},
      {type: "map_click", fnc: ({detail}) => {
        const obj = detail.event.object

        if (detail.mode === "cursor" && obj && !obj.bbox && !!obj.properties.video_settings) {
          this.setState({edit_layer_id: obj.properties.id, video_settings: obj.properties.video_settings})
          broadcast("layer_edit", {id: obj.properties.id, type: "video"})
          broadcast("video_settings", {user_id: this.props.user_id, video_settings: obj.properties.video_settings})

          video_layer_edges(obj.properties.id, obj.properties.video_settings)
        } else {
          if (detail.mode === "video") {
            post_gql(
              `mutation { geomapLayerCreate(
                geomap_id: "${window.location.pathname.replace("/t/", "")}",
                user_id: "${this.props.user_id}",
                type: VIDEO,
                point_coords: ${JSON.stringify(detail.event.coordinate)},
                video_settings: {
                  url: ${JSON.stringify(this.state.video_settings.url)},
                  coord1: ${JSON.stringify(this.state.video_settings.coord1)},
                  coord2: ${JSON.stringify(this.state.video_settings.coord2)},
                  coord3: ${JSON.stringify(this.state.video_settings.coord3)},
                  coord4: ${JSON.stringify(this.state.video_settings.coord4)},
                  min_zoom: ${this.state.video_settings.min_zoom},
                  max_zoom: ${this.state.video_settings.max_zoom},
                }){id user_id point_coords type video_settings {
                  url
                  coord1 coord2 coord3 coord4
                  min_zoom max_zoom
              }}}`,
              resp => {
                const props = resp.data.data.geomapLayerCreate
                broadcast("add_or_replace_layer", video_layer(props))
              }
            )
          }
        }
      }},
      {type: "video_url", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, url: detail.value}})},
      {type: "video_coord1", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord1: detail.value}})},
      {type: "video_coord2", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord2: detail.value}})},
      {type: "video_coord3", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord3: detail.value}})},
      {type: "video_coord4", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord4: detail.value}})},
      {type: "video_min_zoom", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, min_zoom: detail.value}})},
      {type: "video_max_zoom", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, max_zoom: detail.value}})},

      {type: "update_video_url", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, url: detail.value}})},
      {type: "update_video_coord1", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord1: detail.value}})},
      {type: "update_video_coord2", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord2: detail.value}})},
      {type: "update_video_coord3", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord3: detail.value}})},
      {type: "update_video_coord4", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, coord4: detail.value}})},
      {type: "update_video_min_zoom", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, min_zoom: detail.value}})},
      {type: "update_video_max_zoom", fnc: ({detail}) => this.setState({video_settings: {...this.state.video_settings, max_zoom: detail.value}})}
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (this.state.mode === 'video' || !!this.state.edit_layer_id){
      return(
        <div className="polygon-tool" style={{top: this.state.top, left: this.state.left}}>
          <div
            className="tool-header"
            onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
            onMouseUp={e => this.setState({mouse_down_coords: false})}
          >
            <span className="tool-header-title">&nbsp;{this.state.edit_layer_id ? "редактирование" : "настройки"} видео</span>
            <div className="tool-header-btns">
              <span
                className="tool-header-btn"
                onClick={() => this.setState({hidden: !this.state.hidden})}
              >{this.state.hidden ? "▾" : "▸"}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => {
                  broadcast("remove_layer", `${this.state.edit_layer_id}_1_video_edge`)
                  broadcast("remove_layer", `${this.state.edit_layer_id}_2_video_edge`)
                  broadcast("remove_layer", `${this.state.edit_layer_id}_3_video_edge`)
                  broadcast("remove_layer", `${this.state.edit_layer_id}_4_video_edge`)
                  broadcast("toolbar_mode_change", {mode: 'cursor'})
                  broadcast("layer_edit", {id: false, type: "video"})
                }}
              >+</span>
            </div>
          </div>
          {
            this.state.hidden ? null :
            <div className="tool-body">
              <div className="tool-body-header" onClick={() => this.setState({common_hidden: !this.state.common_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;основные</span>
                <span className="tool-header-btn">{this.state.common_hidden ? "▾" : "▸"}&nbsp;</span>
              </div> {
                this.state.common_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">ссылка</span>
                      <input
                        className="tool-input"
                        value={this.state.video_settings.url}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_video_url" : "video_url", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">зум мин.</span>
                      <input
                        className="tool-input"
                        value={this.state.video_settings.min_zoom}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_video_min_zoom" : "video_min_zoom", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>

                    <div className="tool-input-cont">
                      <span className="tool-input-label">зум макс.</span>
                      <input
                        className="tool-input"
                        value={this.state.video_settings.max_zoom}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_video_max_zoom" : "video_max_zoom", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                  </div>
              }
            </div>
          }
        </div>
      )
    } else {
      return(null)
    }
  }
}

export default VideoTool;
